// extracted by mini-css-extract-plugin
module.exports =  {"floating-box":"floating-box--R7x4C","floatingBox":"floating-box--R7x4C"};